export const OVERALL_BUSINESS_PROFILE_STATUS_LABELS = {
  ONBOARDED: 'Linked',
  COMPLETED: 'Completed',
};

export const OVERALL_BUSINESS_PROFILE_STATUS_COLORS = {
  COMPLETED: 'success',
  ONBOARDED: 'info',
};

export const BUSINESS_PROFILE_COMPLETED_STATUS = 'COMPLETED';

export const isBusinessProfileComplete = (profile) => profile?.status === BUSINESS_PROFILE_COMPLETED_STATUS;
